export default __webpack_public_path__ + "static/media/fuelEnDetailRound.026fbadf.jpg";